import { AxiosResponse } from 'axios'
import { RequestREAD, RequestCDU } from 'services/Instances'

export const logicalEffectiveParamsServices = () => {
    const path = 'ParametrizacaoEfetivoLogico'

    // const create = async (requestObj: any): Promise<AxiosResponse> =>
    //     await RequestCDU.post(`${path}/Create`, requestObj)

    // const patch = async (requestObj: logicalEffectiveParams): Promise<AxiosResponse> =>
    //     await RequestCDU.patch(`${path}/Update`, requestObj)

    //const get = async (id: number): Promise<AxiosResponse<IEffectiveParams>> =>
    //await RequestREAD.get(`${path}/${id}`)

    const get = async (): Promise<AxiosResponse<logicalEffectiveParams>> =>
        await RequestREAD.get(`${path}`)

    const createOrUpdate = async (requestObj: RequestlogicalEffectiveParams): Promise<AxiosResponse> =>
        await RequestCDU.post(`${path}/CreateOrUpdate`, requestObj)

    return { get, createOrUpdate }


}

export interface logicalEffectiveParams {
    idParametrizacaoEfetivoLogico?: number
    qtDiasPrimeiraCobranca: number,
    qtDiasSegundaCobranca: number,
    qtDiasTerceiraCobranca: number,
    qtDiasBloqueio: number,
    txMatricula: string,
    updatedDate: Date

}

export interface RequestlogicalEffectiveParams {
    qtDiasPrimeiraCobranca: number,
    qtDiasSegundaCobranca: number,
    qtDiasTerceiraCobranca: number,
    qtDiasBloqueio: number,
}